import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';

/**
 * LegalLayout — минимальный layout для публичных правовых страниц
 * (Политика конфиденциальности, Условия использования, Поддержка).
 *
 * Отличается от AuthLayout отсутствием auth-брендинга «Welcome Back»
 * и наличием кнопки «Назад» (history.back).
 */
const LegalLayout = ({ title, lastUpdated, children }) => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-background flex flex-col">
            <header className="bg-surface border-b border-border">
                <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex items-center justify-between h-16">
                        <Link to="/" className="flex items-center gap-3">
                            <div className="w-8 h-8 bg-primary rounded-md flex items-center justify-center">
                                <Icon name="Shield" size={20} className="text-white" />
                            </div>
                            <div>
                                <h1 className="text-lg font-semibold text-text-primary">SecureAuth</h1>
                                <p className="text-xs text-text-secondary">Enterprise System</p>
                            </div>
                        </Link>

                        <button
                            onClick={() => navigate(-1)}
                            className="flex items-center gap-2 text-sm text-text-secondary hover:text-primary transition-colors duration-150"
                        >
                            <Icon name="ArrowLeft" size={16} />
                            Назад
                        </button>
                    </div>
                </div>
            </header>

            <main className="flex-1 px-4 sm:px-6 lg:px-8 py-10">
                <div className="max-w-3xl mx-auto">
                    <div className="bg-surface rounded-lg shadow-sm border border-secondary-200 p-6 sm:p-10">
                        <h1 className="text-3xl font-semibold text-text-primary">{title}</h1>
                        {lastUpdated && (
                            <p className="mt-2 text-sm text-text-secondary">
                                Последнее обновление: {lastUpdated}
                            </p>
                        )}

                        <div className="mt-8 space-y-6 text-text-primary leading-relaxed">
                            {children}
                        </div>
                    </div>

                    <div className="mt-6 flex items-center justify-center gap-6 text-sm text-text-secondary">
                        <Link to="/privacy" className="hover:text-primary transition-colors duration-150">
                            Политика конфиденциальности
                        </Link>
                        <Link to="/terms" className="hover:text-primary transition-colors duration-150">
                            Условия использования
                        </Link>
                        <Link to="/support" className="hover:text-primary transition-colors duration-150">
                            Поддержка
                        </Link>
                    </div>

                    <p className="mt-4 text-xs text-secondary-400 text-center">
                        © {new Date().getFullYear()} SecureAuth Enterprise. Все права защищены.
                    </p>
                </div>
            </main>
        </div>
    );
};

export const LegalSection = ({ title, children }) => (
    <section className="space-y-3">
        <h2 className="text-xl font-semibold text-text-primary border-l-4 border-primary pl-3">
            {title}
        </h2>
        <div className="text-text-secondary text-sm space-y-2">{children}</div>
    </section>
);

export default LegalLayout;
